import React from 'react'
import classnames from 'classnames'
import './view-toggle.css'

const GridSVG = (
  <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-6.000000, -6.000000)" fill="#FFFFFF">
          <rect x="6" y="6" width="4" height="4"></rect>
          <rect x="6" y="12" width="4" height="4"></rect>
          <rect x="12" y="6" width="4" height="4"></rect>
          <rect x="12" y="12" width="4" height="4"></rect>
        </g>
    </g>
</svg>
)

const ListSVG = (
  <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-6.000000, -6.000000)" fill="#FFFFFF">
          <rect x="6" y="6" width="3" height="4"></rect>
          <rect x="6" y="12" width="10" height="4"></rect>
          <rect x="11" y="6" width="5" height="4"></rect>
        </g>
    </g>
</svg>
)

const getActive = (inViewport, currentPageName) => {
  if (currentPageName !== 'HOME') return true
  if (!inViewport ) return true
  return false
}

const ViewToggle = ({ currentPageName, inViewport, viewMode, onToggle }) => (
  <div onClick={onToggle} className={classnames({'view-toggle--active': getActive(inViewport, currentPageName)}, 'view-toggle')}>
    {viewMode ? ListSVG : GridSVG}
  </div>
)

export default ViewToggle



// WEBPACK FOOTER //
// ./src/components/view-toggle/view-toggle.js